var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{style:({ width: _vm.width + 'px', height: _vm.height + 'px' }),domProps:{"value":_vm.value},on:{"input":e => _vm.$emit('input', e.target.value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }